import React from 'react';
import { useRefinementList } from 'react-instantsearch';

const RefinementList = (props) => {
    // eslint-disable-next-line no-unused-vars
    const {items, hasExhaustiveItems, createURL, refine, sendEvent, searchForItems, isFromSearch, canRefine, canToggleShowMore, isShowingMore, toggleShowMore} = useRefinementList(props);

    /* const filteredItems = items.filter((item) => {
      const parts = item.label.split(' > ');
      if (parts.length > 1) {
          if (parts[0] == props.category) {
              return true;
          } else {
              return false;
          }
      }
      return true;
  }).map((item) => {
        const parts = item.label.split(' > ');
          if (parts.length > 1) {
              item.label = parts[1];
          }
        return item;
    })*/

    let filteredItems = items;

    if (props.attribute == 'type' && props.types) {
        const types = props.types.split('|');

        filteredItems = items.filter((item) => types.includes(item.label));
    }

    if (filteredItems.length == 0) {
        return (<></>);
    }

    return (
        <div key={props.attribute}>
            <fieldset>
                <details open={props.open}>
                    <summary className="cursor-pointer outline-none">
                        <span className="flex items-center justify-between">
                            <span className="pr-4">
                                <legend className="font-bold">{props.title}</legend>
                            </span>
                            <span className="mt-1 md:mt-0">
                                <svg className="stroke-current text-green w-3.5 h-3.5" width="14" height="14" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <path fill="none" className="horizontal-stroke origin-center transform transition-transform duration-200 ease-in-out" strokeWidth="12" d="m 32,4.962098 0,53.893986"/>
                                        <path fill="none" className="vertical-stroke" strokeWidth="12" d="m 5.1127494,31.909091 53.8342436,0"/>
                                    </g>
                                </svg>
                            </span>
                        </span>
                    </summary>

                    <div data-accordion className="transition-all duration-500 overflow-hidden">
                        <div className="mt-4">
                            <div>
                                {filteredItems.map((item) => (
                                    <label key={item.label} className="flex items-start mb-3">
                                        <div className="flex items-center">
                                            <input
                                                checked={item.isRefined}
                                                onChange={() => refine(item.value)}
                                                type="checkbox"
                                                className="styled-input form-tick"
                                            />
                                        </div>
                                        <div className="pl-3 flex-1 max-w-[220px]">
                                            <span className="text-sm block">
                                                {item.label}
                                            </span>

                                            {props.subnodes.filter(b => b.key == item.label)[0]?.items.length > 0 && <ul className="text-sm text-grey-500/90 flex flex-col gap-0.5 mt-1.5">
                                                <li>{props.translation}:</li>
                                                {props.subnodes.filter(b => b.key == item.label)[0]?.items.map((sub) => (
                                                    <li key={sub}>{sub}</li>
                                                ))}
                                            </ul>}
                                        </div>
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>
                </details>
                <hr className="mt-4 h-px border-grey-200" />
            </fieldset>
        </div>

    );
}

export { RefinementList }
